import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

export interface FullScreenDialogProps {
	// label for open button
	label: string;
	// dialog title
	title: string;
	// children to render as dialog body
	children?: React.ReactNode;
	// custom actions to appear in header
	actions?: React.ReactNode;
	// is open by default
	isOpen?: boolean;
	// function to emit state change
	emitState?: (isOpen: boolean) => void;
}

/**
 * Configurable full screen dialog with dynamic body
 * @param props
 */
export const FullScreenDialog = (props: FullScreenDialogProps) => {
	const [open, setOpen] = React.useState(!!props.isOpen);

	React.useEffect(() => {
		setOpen(!!props.isOpen);
	}, [props.isOpen]);

	const setOpenState = (newState: boolean) => {
		if (props.emitState) {
			props.emitState(newState);
		} else {
			setOpen(newState);
		}
	};
	/**		title: {
			marginLeft: theme.spacing(2),
			flex: 1,
		},
		dialogBody: {
			margin: theme.spacing(4),
		},
		 */
	return (
		<div>
			<Button
				size="small"
				data-testid="full-screen-dialog-open-btn"
				variant="outlined"
				color="primary"
				onClick={() => setOpenState(true)}
			>
				{props.label}
			</Button>
			<Dialog data-testid="full-screen-dialog-container" fullScreen open={open} onClose={() => setOpenState(false)}>
				<AppBar color="default" position="fixed">
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={() => setOpenState(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" style={{ marginLeft: 16, flex: 1 }}>
							{props.title}
						</Typography>
						<span>{props.actions}</span>
					</Toolbar>
				</AppBar>
				<Toolbar />
				<div style={{ margin: 32 }}>{props.children}</div>
			</Dialog>
		</div>
	);
};
